import { render } from "./SideMenu.vue?vue&type=template&id=6e166926&scoped=true&ts=true"
import script from "./SideMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideMenu.vue?vue&type=script&setup=true&lang=ts"

import "./SideMenu.vue?vue&type=style&index=0&id=6e166926&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e166926"],['__file',"src/layouts/inc/SideMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e166926"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e166926', __exports__)) {
    api.reload('6e166926', __exports__)
  }
  
  module.hot.accept("./SideMenu.vue?vue&type=template&id=6e166926&scoped=true&ts=true", () => {
    api.rerender('6e166926', render)
  })

}


export default __exports__